import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
	ViewEncapsulation
} from '@angular/core';

declare let d3;

import { SpeakerService } from '../speaker.service';

@Component({
	selector: 'bar-chart',
	templateUrl: 'bar-chart.component.html',
	styleUrls: ['bar-chart.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class BarChartComponent implements OnInit {
	@ViewChild('bar') bar: ElementRef;
	@Input() category = 'proficiency';
	@Output() onChartClick = new EventEmitter();
	
	// PLOT DATA VARIABLE
	plotData;
	
	absoluteVals: any;
	
	
	// DATA OPTIONS
	options = {
		scales: {
			yAxes: [
				{ ticks: {
						beginAtZero: true
					},
					scaleLabel: {
						display: true,
						labelString: 'Relative Frequency per 10,000'
					}
				}
			]
		},
		tooltips: {
			enabled: true,
			mode: 'single',
			displayColors: false,
			callbacks: {
				label: (tooltipItem, data) => {
					return [
						SpeakerService.numberFormat(Number(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]), 2),
						'(' + SpeakerService.numberFormat(this.absoluteVals[this.socialKeys[tooltipItem.index]]) + ')'
					];
				}
			}
		}
	};
	
	socialKeys = ['B1', 'B2', 'C1', 'C2', 'NS'];
	
	public barColors: any[];
	
	public barChartOptions:any = {
		scaleShowVerticalLines: false,
		responsive: true
	};
	
	public barChartLabels:string[] = [];
	public barChartType:string = 'bar';
	public barChartLegend:boolean = true;
	
	constructor(private speakerSrv: SpeakerService) { }
	
	ngOnInit(): void {
		this.speakerSrv.statsChange.subscribe(stats => { this.update(stats); });
		
		this.barColors = [];
		let ctx = this.bar.nativeElement.getContext('2d');
		let grad1 = ctx.createLinearGradient(0, 0, 0, 200);
		grad1.addColorStop(0, '#c47eee');
		grad1.addColorStop(1, '#e86dd0');
		
		let grad2 = ctx.createLinearGradient(0, 0, 0, 200);
		grad2.addColorStop(0, '#d3f77f');
		grad2.addColorStop(1, '#eac26c');
		
		this.barColors.push({backgroundColor: grad1, hoverBackgroundColor: grad1});
		this.barColors.push({backgroundColor: grad2, hoverBackgroundColor: grad2});
	}
	
	update(stats) {
		let data = { labels: ['Candidate', 'Examiner'] };
		// If array is not empty
		if (Object.keys(stats).length > 0) {
			//Set Keys to the chart type
			let keys;
			switch (this.category) {
				case "proficiency":
					keys = this.socialKeys;
					this.barChartLabels = this.socialKeys;
					break;
				default:
					keys = [];
					break;
			}
			
			// Create an object that has the total value of all the keys added together
			 let obj = keys.reduce(function(acc, cur, i) {
				acc[cur] = 0;
				return acc;
			}, {});
			
			let absObj = keys.reduce((acc, cur, i) => {
				acc[cur] = 0;
				return acc;
			}, {});
			
			// Assign Corpus Total Dictionary to categorise data.
			let corpusTotal = { 'Candidate': Object.assign({}, obj), 'Examiner': Object.assign({}, obj) };
			let countTotal = { 'Candidate': Object.assign({}, obj), 'Examiner': Object.assign({}, obj) };
			
			let absTotal = { 'Candidate': Object.assign({}, absObj), 'Examiner': Object.assign({}, absObj) };
			
			// For each data label (1994, 2014)
			for (let i = data.labels.length - 1; i >= 0; i--) {
				// Assign Label to L
				let l = data.labels[i];
				// Create an object for each dataset
				const objKeys = Object.keys(stats[l]);
				// Add data to the corpus total
				for (let j = objKeys.length - 1; j >= 0; j--) {
					// Get stats on one person
					let g = stats[l][objKeys[j]];
					// Add relative frequency to total
					corpusTotal[l][g[this.category]] += g['relative'];
					
					countTotal[l][g[this.category]] += 1;
					
					absTotal[l][g[this.category]] += g['count'];
					
				}
			}
			
			this.absoluteVals = {};
			
			for (let role of data.labels) {
				for (let key of this.socialKeys) {
					if (!this.absoluteVals[key])
						this.absoluteVals[key] = absTotal[role][key]
				}
			}
			
			// console.log(this.absoluteVals);
			
			// console.log(countTotal, corpusTotal);
			
			const values94 = BarChartComponent.generateDataArray(countTotal['Candidate'], corpusTotal['Candidate'], this.socialKeys);
			const values14 = BarChartComponent.generateDataArray(countTotal['Examiner'], corpusTotal['Examiner'], this.socialKeys);
			
			// console.log(values94, values14);
			
			this.plotData =  [
				{
					label: 'Candidate',
					data: values94
				},
				{
					label: 'Examiner',
					data: values14
				}
			];
		}
	}
	// GET CATEGORY
	onDataSelect(event) {
		this.onChartClick.emit({ src: 'CHART-' + this.category, event: event });
	}
	
	static generateDataArray(counts, corpus, keys) {
		let arr = [];
		for (let i = 0; i < keys.length; i++) {
			arr.push(corpus[keys[i]] / counts[keys[i]]);
		}
		return arr;
	}
	
	public chartClicked(event: any) {
		if (event.active.length > 0) {
			let chartElement = event.active[0]._chart.getElementAtEvent(event.event);
			// console.log(chartElement[0]._model.datasetLabel);
			let newEvent = {
				element: {
					_model: {
						datasetLabel: chartElement[0]._model.datasetLabel,
						label: chartElement[0]._model.label
					}
				}
			};
			this.speakerSrv.concordanceProficiencyFilter.next(newEvent);
			this.speakerSrv.changeView('Concordance', event);
		}
	}
}





// WEBPACK FOOTER //
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/bar-chart/bar-chart.component.ts